import http from '@/plugins/http'
import { createReportApi } from '../reportFactory'
const adminApi = process.env.VUE_APP_ADMIN_API;

// 首页（v1 独有）
export const getIndexData = (params={}) => http.fetchGet(adminApi + 'common/indexData', params)

const api = createReportApi('report/')
export const getReportIndexData    = api.getReportIndexData
export const getRecommendCar       = api.getRecommendCar
export const getRankData           = api.getRankData
export const getRankNodeData       = api.getRankNodeData
export const getCarSummaryData     = api.getCarSummaryData
export const getCarScore           = api.getCarScore
export const getCarScoreInnovate   = api.getCarScoreInnovate
export const getTestDetail         = api.getTestDetail
export const getInnovateDetail     = api.getInnovateDetail
export const getInnovateLineDetail = api.getInnovateLineDetail
export const getNodeLineDetail     = api.getNodeLineDetail
export const getNodeLineTwoDetail  = api.getNodeLineTwoDetail
export const addCompareCar         = api.addCompareCar
export const delCompareCar         = api.delCompareCar
export const getCompareCarList     = api.getCompareCarList
export const changeUserCar         = api.changeUserCar
export const searchNode            = api.searchNode
export const getParentNodes        = api.getParentNodes
export const getNodeVideos         = api.getNodeVideos
export const addCollect            = api.addCollect
export const delCollect            = api.delCollect
export const getSearchModel        = api.getSearchModel
export const getSearchResoult      = api.getSearchResoult
export const getSearchCar          = api.getSearchCar
export const getSearchResoultCx    = api.getSearchResoultCx
